/**
 * The preview's viewport toggles: desktop, portrait and landscape. One
 * control for the scene editor's toolbar and the story studio (spec 025).
 */

import React from 'react';
import type { Orientation } from '../../../../Shared/src/@types';
import styles from './OrientationButtons.module.scss';

const MODES: { mode: Orientation; icon: string; title: string }[] = [
  { mode: 'desktop',   icon: '🖥️', title: 'Desktop' },
  { mode: 'portrait',  icon: '📱', title: 'Portrait' },
  { mode: 'landscape', icon: '📱', title: 'Landscape' },
];

interface OrientationButtonsProps {
  orientation: Orientation;
  onChange: (mode: Orientation) => void;
  className?: string;
  /** Test ids are `${testIdPrefix}-${mode}`. */
  testIdPrefix?: string;
}

const OrientationButtons: React.FC<OrientationButtonsProps> = ({
  orientation, onChange, className, testIdPrefix,
}) => (
  <div className={`${styles.group} ${className ?? ''}`} role="group" aria-label="Screen shape">
    {MODES.map(({ mode, icon, title }) => (
      <button
        key={mode}
        type="button"
        className={`${styles.btn} ${orientation === mode ? styles.active : ''} ${mode === 'landscape' ? styles.rotated : ''}`}
        onClick={() => onChange(mode)}
        title={title}
        aria-label={title}
        aria-pressed={orientation === mode}
        data-testid={testIdPrefix ? `${testIdPrefix}-${mode}` : undefined}
      >
        {icon}
      </button>
    ))}
  </div>
);

export default OrientationButtons;
